import { i18n } from '@/lang/i18n';
import Vue from 'vue';
import {
  environmentService,
  bookingService,
  postRequestHandler
} from "@/utils/services";

const DefaultState = () => {
    return {
      apiUrl: null,
      isAvailabilityLoading: false,
      isAvailabilityActive: false,
      isStartedBookingSearch: false,
      availabilities: [],
      availabilityQuantity: null,
      availabilityInObservation: null,
      selectedCurrency: null,
      ages: null,
      searchdata: {
        typeNameService: null,
        area_id: null,
        city_id: null,
        checkin: null,
        checkout: null,
        category: null,
        airportCode: null,
        townId: null,
        rooms: [{
          adults: null,
          children: null,
          ages: [],
        }],
        clientIds: {
          id: null,
          name: null,
          clienttype_id: null,
          type: {
            id: null,
            name: null,
            code: null
          }
        }
      },
      option: [],
      redoSearch:false,
    };
  },

  state = DefaultState(),

  getters = {
    isAvailabilityLoading: state => state.isAvailabilityLoading,
    isAvailabilityActive: state => state.isAvailabilityActive,
    availabilities: state => state.availabilities,
    availabilityQuantity: state => state.availabilityQuantity,
    availabilityInObservation: state => state.availabilityInObservation,
    selectedCurrency: state => state.selectedCurrency,
    ages: state => state.ages,
    searchdata: state => state.searchdata,
    option: state => state.option,
    redoSearch: state => state.redoSearch,
  },

  mutations = {
    setAges(state, payload) {
      state.ages = payload;
    },
    setSearchData(state, payload) {
      state.searchdata = payload
    },
    setAvailabilityUrls(state) {
      state.apiUrl = environmentService.apiUrlAvailability;
    },
    setrooms(state, payload) {
      if(state.option.length < 1){
        state.option = []
        state.option = state.availabilityInObservation.availability[0]
        state.option.selected = 0
      }
    },
    setRoomsToShow(state, payload){
      state.option = []
      state.option = payload.data
      state.option.selected = payload.select
    },
    setSelectedCurrency(state, payload) {
      state.selectedCurrency = payload;
    },
    setAvailabilities(state, payload) {
      state.availabilities = payload;
    },
    clearAvailabilitiesAndResponse(state) {
      state.availabilities = [];
    },
    setAvailabilityQuantity(state, payload) {
      state.availabilityQuantity = payload;
    },
    setAvailabilityInObservation(state, payload) {
      state.availabilityInObservation = payload;
    },
    toggleAvailabilityLoading(state, payload) {
      state.isAvailabilityLoading = payload;
    },
    toggleAvailabilityActive(state, payload) {
      state.isAvailabilityActive = payload;
    },
    toggleStartedBookingSearch(state, payload) {
      state.isStartedBookingSearch = payload;
    },
    resetAvailabilityInObservation(state) {
      state.availabilityInObservation = null;
    },
    resetOptionSelected(state){
      state.option = []
    },
    RESET_STATE(state) {
      Object.assign(state, DefaultState());
    },
    RESET_RATE_TO_SHOW(state) {
      Object.assign(state.option, DefaultState().rooms);
    },
    setReSearch(state, payload) {
      state.redoSearch =  payload;
    },
    resetAvailabilities(state) {
      state.availabilities = [];
    }
  },

  actions = {
    setAges({
      commit
    }, payload) {
      commit('setAges', payload);
    },
    setAvailabilityUrls({
      commit
    }) {
      commit('setAvailabilityUrls');
    },
    setrooms({
      commit
    }, payload) {
      commit('setrooms', payload);
    },
    setRoomsToShow({commit}, payload){
      commit('setRoomsToShow', payload)
    },
    setguests({
      commit
    }, payload) {
      commit('setguests', payload);
    },

    setAvailabilityInObservation({
      commit
    }, payload) {
      commit('setAvailabilityInObservation', payload);
    },

    toggleAvailabilityActive({
      commit
    }, payload) {
      commit('toggleAvailabilityActive', payload);
    },

    toggleAvailabilityLoading({
      commit
    }, payload) {
      commit('toggleAvailabilityLoading', payload);
    },

    setReSearch({commit}, payload) {
      commit('setReSearch', payload);
    },

    toggleStartedBookingSearch({
      commit
    }, payload) {
      commit('toggleStartedBookingSearch', payload);
    },
    async getAvailabilities({
      commit,
      state,
      dispatch,
      rootState
    }, payload) {
      i18n.locale = rootState.global.locale;
      var search_payload = {
        "currency": payload.area_id,
        "operators": payload.operators,
        "townId": payload.townId,
        "rooms": payload.rooms,
        "checkin": payload.checkin,
        "checkout": payload.checkout
      };

      let records = await postRequestHandler(`${state.apiUrl}/availability`, search_payload, {
        headers: rootState.auth.headers
      });
      commit('toggleAvailabilityLoading', false);
      commit('toggleAvailabilityActive', false);

      if (records.availabilities) {
        commit('setSearchData', payload);
        commit('setAvailabilities', records.availabilities.data.data);
        commit('setAvailabilityQuantity', records.availabilityQuantity);
        commit('setSelectedCurrency', payload.area_id);

        if (records.availabilityQuantity >0) {
          dispatch('global/setToastNotification', {title:i18n.t('lang.store.availability.Availability'), text:records.availabilityQuantity +' '+i18n.t('lang.store.availability.hotelsFound'), type:'success'}, {root: true});
        } else {
          dispatch('global/setToastNotification', {title:i18n.t('lang.store.availability.Availability'), text:i18n.t('lang.store.availability.noAvailability'), type:'danger'}, {root: true});
        }
      } else {
        dispatch('global/setToastNotification', {title:i18n.t('lang.store.availability.Availability'), text:i18n.t('lang.store.availability.noAvailability'), type:'danger'}, {root: true});
      }
    },

    resetAvailabilityInObservation({
      commit
    }) {
      commit('resetAvailabilityInObservation');
    },
    resetOptionSelected({commit}){
      commit('resetOptionSelected');
    },
    resetSearchData({
      commit
    }) {
      commit('clearAvailabilitiesAndResponse');
    },
    RESET_STATE({
      commit
    }) {
      commit('RESET_STATE');
    },
    RESET_RATE_TO_SHOW({
      commit
    }) {
      commit('RESET_RATE_TO_SHOW');
    },
    resetAvailabilities({commit}) {
      commit('resetAvailabilities');
    }
  };

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};



// WEBPACK FOOTER //
// ./src/store/modules/availability.js